/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLabelIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-label"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.85 20.8Q2.73 20.8 1.96 20.04Q1.2 19.27 1.2 18.15L1.2 5.85Q1.2 4.72 1.96 3.96Q2.73 3.2 3.85 3.2L14.97 3.2Q15.63 3.2 16.19 3.49Q16.75 3.77 17.13 4.28L21.65 10.43Q22.15 11.13 22.15 12Q22.15 12.88 21.65 13.57L17.13 19.73Q16.75 20.23 16.19 20.51Q15.63 20.8 14.97 20.8Z" fill={color} />
    </svg>
  );
}
